"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_styles_1 = require("@/components/common/button/button.styles");
const toggle_controller_1 = require("@/controllers/toggle-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common/icon/icon");
let ToggleButton = class ToggleButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.pressed = false;
        this.value = '';
        this.disabled = false;
        this.ariaLabel = '';
        this.toggle = new toggle_controller_1.ToggleController(this, 'pressed');
    }
    render() {
        return (0, lit_1.html) `
      <button
        type="button"
        ?disabled=${this.disabled}
        aria-pressed=${this.pressed ? 'true' : 'false'}
        aria-label=${this.ariaLabel || lit_1.nothing}
        @click=${this.handleClick}
      >
        ${this.renderIcon()} ${this.renderLabel()}
      </button>
    `;
    }
    renderIcon() {
        if (!this.icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${this.icon}></mm-icon>
    `;
    }
    renderLabel() {
        if (this.pressed && this.pressedLabel)
            return this.pressedLabel;
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
    handleClick(event) {
        event.stopPropagation();
        this.toggle.toggle();
    }
};
ToggleButton.styles = [shared_styles_1.resetStyles, button_styles_1.buttonBaseStyles, button_styles_1.toggleButtonStyles, button_styles_1.buttonSelectedStyles];
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ToggleButton.prototype, "pressed", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'pressed-label' })
], ToggleButton.prototype, "pressedLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ToggleButton.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ToggleButton.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ToggleButton.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], ToggleButton.prototype, "ariaLabel", void 0);
ToggleButton = __decorate([
    (0, decorators_js_1.customElement)('mm-toggle-button')
], ToggleButton);
exports.ToggleButton = ToggleButton;
//# sourceMappingURL=data:application/json;base64,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